module.exports = __webpack_public_path__ + "static/img/serie_a.666814e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/serie_a.png
// module id = Ariy
// module chunks = 1